import { PROJECT_CREATE_POPUP } from '../../actions/actionsNamesList';

const {
    OPEN, CLOSE, SET_DATA, SHOW_VALIDATION_ERRORS, HIDE_VALIDATION_ERRORS
} = PROJECT_CREATE_POPUP;

const defaultState = {
    isOpened: false,
    showErrors: false,
    view: 'name',
    name: '',
    isNameUnique: false,
    isNameUniquenessChecking: false,
    description: ''
};

export default function projectEditPopupData(state = defaultState, action) {
    switch (action.type) {
        case OPEN: {
            return {
                ...state,
                isOpened: true
            };
        }
        case CLOSE: {
            return {
                ...state,
                isOpened: false
            };
        }
        case SHOW_VALIDATION_ERRORS: {
            return {
                ...state,
                showErrors: true
            };
        }
        case HIDE_VALIDATION_ERRORS: {
            return {
                ...state,
                showErrors: true
            };
        }
        case SET_DATA: {
            return {
                ...state,
                ...action.data
            };
        }
        default: {
            return { ...state };
        }
    }
}